<template>
  <div class="drawer-detail">
    <div v-for="field in ['面试安排', '面试流程','推荐备注','特殊要求寻访']" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <div :class="[company[field]?'':'gray-text','value company-pre']">
        <p v-if="company[field]">{{company[field]}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="field-type">
      <span class="label">对接hr:</span>
      <div class="new-hr-box">
        <el-tooltip v-for="item in contact" :key="item._id" effect="dark" :visible-arrow="false" popper-class="alpha-color-ccc" placement="left">
          <div slot="content">
            <p>职级：{{item.职级}}</p>
            <p>手机：{{item.手机}}</p>
            <p>座机：{{item.座机}}</p>
            <p>职级：{{item.职级}}</p>
            <p>邮箱：{{item.邮箱}}</p>
          </div>
          <div class="new-hr">
            <span class="name">
              <span v-if="!item.rid">{{ item.姓名 || '' }}</span>
              <span v-else style="cursor:pointer;" @click="showRadish({ id: item.rid })">{{ item.姓名 }}</span>
            </span>
            <span>{{ item.目前职位 || '' }}</span>
          </div>
        </el-tooltip>
      </div>
      <!-- <ul class="hrcardbox">
        <li v-for="item in contact" :key="item._id" class="hrcard">
          <div class="half-box">
            <span class="name">
              <span v-if="!item.rid">{{ item.姓名 || '' }}</span>
              <span v-else class="drawer-link" @click="showRadish({ id: item.rid })">{{ item.姓名 }}</span>
            </span>
            <div class="job-box">
              <p class="gray">{{ item.目前职位 }}</p>
              <p class="gray">{{ item.职级 }}</p>
            </div>
          </div>
          <div class="half-box contact">
            <p class="tel">{{ item.手机 }}</p>
            <p class="gray">{{ item.座机 }}</p>
            <p class="gray">{{ item.邮箱 }}</p>
          </div>
        </li>
      </ul> -->
    </div>
    <div class="field-type">
      <span class="label">面试地址:</span>
      <el-tooltip v-for="(item, index) in company.面试地址" :key="index + 2" effect="dark" :visible-arrow="false" popper-class="alpha-color-ccc" placement="left">
        <div slot="content">
          <p>地址：{{item.地址}}</p>
          <p>备注：{{item.备注}}</p>
        </div>
        <div class="address-card">
          <span class="address">{{ item.地址&&item.地址.length>13?`${item.地址.slice(0,13)}...`:item.地址 }}</span>
        </div>
      </el-tooltip>
      <!-- <ul>
        <li v-for="(item, index) in company.面试地址" :key="index + 2" class="address-card" style="margin: 0 auto 6px;">
          <span class="address">{{ item.地址 }}</span> <span class="remark">{{ item.备注 }}</span>
        </li>
      </ul> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['面试安排', '面试流程','推荐备注','特殊要求寻访', '对接hr', '面试地址'],
      translateTag: {
        推荐备注: '推荐要求',
        特殊要求寻访: '其他特殊要求',
      },
      contact: [],
    }
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        if (newValue && newValue.对接hr && !oldValue) this.getCompanyHr()
        else if (
          newValue &&
          oldValue &&
          JSON.stringify(newValue.对接hr || []) !== JSON.stringify(oldValue.对接hr || [])
        ) {
          this.getCompanyHr()
        } else if (newValue && !newValue.对接hr) this.contact = []
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async getCompanyHr(leaders) {
      const hrs = this.company.对接hr
      const res = await app.service('company').getCompanyHr(hrs || [])
      if (res.status === 'success') this.contact = res.data
      else {
        this.$message(res.msg)
        this.contact = []
      }
    },
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}

.hrcardbox {
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.hrcard {
  min-width: 200px;
  padding: 8px 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0px 2px 8px 0px rgba(224, 224, 224, 0.5);
  border-radius: 6px;
  margin: 6px;
}
.hrcard .half-box {
  width: 50%;
  float: left;
  padding: 0 2px;
}
.hrcard .name {
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  padding-right: 21px;
  text-align: left;
}
.hrcard .job-box {
  width: 100%;
}
.hrcard .job-box span {
  width: 50%;
}
.hrcard .tel {
  font-weight: 600;
}
.hrcard .contact p {
  word-break: break-word;
}
.hrcard .gray {
  color: #a4a3ac;
}
.address-card {
  padding: 0 10px;
}
.address-card::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 6px;
}
.address-card span {
  display: block;
}
.address-card .address {
  font-weight: 600;
  font-size: 14px;
}
.address-card .remark {
  font-size: 14px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
